'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.carousel.edit', [])
  .controller('CarouselEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/carousel/edit/index.js